import { Observable, finalize, tap } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export function withLoading<T>(loadingSubject: BehaviorSubject<boolean>) {
  return (source$: Observable<T>): Observable<T> => {
    loadingSubject.next(true);
    
    return source$.pipe(
      finalize(() => loadingSubject.next(false))
    );
  };
}
